import type { IClientUser } from '../interfaces/user';
import React from 'react';
import BrandOnboardingForm from '../components/User/Forms/OnboardingForm/BrandOnboardingForm';
import logo from '../assets/svg/onboarding/logo.svg';

const BrandOnboardingPage: React.FC<IClientUser> = () => {
    return (
        <main className="page-onboarding">
            <nav className="navbar onboarding-navbar">
                <div className="container">
                    <div className="navbar-brand">
                        <a href="/" className="navbar-item logo-link">
                            <img src={logo} alt="Match Hat" className="logo" />
                        </a>
                    </div>
                    <div className="navbar-menu">
                        <div className="navbar-end">
                            <div className="navbar-item">
                                <a href="/login" className="button onboarding-login-button">
                                    Log In
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <section className="container m-t-0">
                <div className="columns section">
                    <div
                        className="column is-three-quarters-tablet is-full-mobile"
                    >
                        <BrandOnboardingForm />
                    </div>
                </div>
            </section>
        </main>
    );
};

export default BrandOnboardingPage;